import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    MeetingDuplicateInputFieldInput as DuplicateMeetingInput,
    DuplicateMeeting as DuplicateMeetingMutation,
    DuplicateMeetingVariables as DuplicateMeetingMutationVariables,
} from 'nutshell-graphql-types';

import DUPLICATE_MEETING from '../mutations/duplicate-meeting.graphql';

export function useDuplicateMeeting(): {
    duplicateMeeting: (arg1: DuplicateMeetingInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const [duplicateMeeting, {loading, error}] = useMutation<
        DuplicateMeetingMutation,
        DuplicateMeetingMutationVariables
    >(DUPLICATE_MEETING);

    return {
        duplicateMeeting: (input: DuplicateMeetingInput) =>
            duplicateMeeting({variables: {input}}).then(
                (result) =>
                    result &&
                    result.data &&
                    result.data.meetingDuplicate &&
                    result.data.meetingDuplicate.meeting &&
                    result.data.meetingDuplicate.meeting.htmlUrlPath
            ),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
